import { MetricsSidebar } from './components/metrics-sidebar/metrics-sidebar';
import { MetricDetailPanel } from './components/metric-detail-panel/metric-detail-panel';
import { useQualityMetricsContext } from './quality-metrics-context';
import { Loader } from 'src/components/core';
import { NotFound } from 'src/components/common';
import styles from './quality-metrics.module.scss';

export function QualityMetricsLayout() {
  const { metrics, loading, error } = useQualityMetricsContext();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <NotFound />;
  }

  if (!metrics?.length) {
    return <NotFound />;
  }

  return (
    <div className={styles.layout}>
      <MetricsSidebar />
      <MetricDetailPanel />
    </div>
  );
}
